import React, { useState } from 'react';
import Modal from './Modal';
import {nextApi} from './../data/nextApi';

const NextComp = () => {
    const [nextData, setNextData] = useState(nextApi);

    const [modal, setModal] = useState(false);
    const [tempdata, setTempdata] = useState({});
    const modalBtn = (curr) => {
      setTempdata({ ...curr });
      return setModal(true);
    };
    return (
        <>
        <div className="container-fluid">
          <div className="row mt-5">
          <h1 className="text-center text-danger pb-4">works in process. Stay tuned. Thank you</h1>
            <div className="col-lg-10 col-12 mx-auto">
              <div className="card-columns">
                {nextData.map((curr) => {
                  return (
                    <>
                      <div className="card" key={curr.id}>
                        <div className="hovereffect">
                          <img
                            className="img-responsive card-img-top"
                            src={curr.img}
                            alt=""
                          />
                          <div className="overlay">
                            <button
                              className="overlyBtn"
                              onClick={() => modalBtn(curr)}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
  
              {modal === true ? (
                <Modal data={tempdata} hide={() => setModal(false)} />
              ) : (
                ""
              )}
              
            </div>
          </div>
        </div>
      </>
    );
};

export default NextComp;